<template>
        <div class=" col-lg-3" >
            <small class="d-block text-uppercase font-weight-bold mb-4">{{title}}</small>
            <img v-lazy="imageAfter" alt="Rounded image" class="img-fluid rounded shadow card card-lift--hover shadow border-0"
                 style=" cursor: pointer;" @click="modals.modal1 = true">
           
            <modal :show.sync="modals.modal1" :showClose="true">
                  <!-- <VueCompareImage :leftImage="imageBefore" :rightImage="imageAfter" />           -->
                  <img v-lazy="imageAfter" alt="Rounded image" class="img-fluid rounded shadow card card-lift--hover shadow border-0"
                 style="cursor: pointer;">
            </modal>
        </div>
</template>
<script>
import Modal from "@/components/Modal.vue";
import VueCompareImage from 'vue-compare-image';

export default {
    props: ['imageBefore', 'imageAfter', 'title'],
  components: {
    VueCompareImage,
    Modal
  },
  data() {
    return {
      modals: {
        modal1: false,
      }
    };
  }
};
</script>
<style>
</style>
